import { createAction } from "redux-actions";
import { API_START, API_END, API } from "../constants/actionTypes";
import { apiPayloadCreator } from "../utils/appUtils";
import { notification } from "antd";
import { callApiLabel } from "../constants/labels";

export const apiStart = createAction(API_START);
export const apiEnd = createAction(API_END);

const apiAction = createAction(API, apiPayloadCreator);

export const callApi = (
  method,
  url,
  data,
  onSuccessWithoutDispatch,
  onFailureWithoutDispatch,
  onSuccess,
  onFailure
) =>
  apiAction({
    label: callApiLabel,
    method: method,
    url: url,
    onSuccessWithoutDispatch: onSuccessWithoutDispatch,
    onFailureWithoutDispatch: onFailureWithoutDispatch,
    onSuccess: onSuccess,
    onFailure: onFailure,
    data: data,
  });